import { useState, useEffect, useCallback } from "react"

export function useDontShowAgain({
  localStorageKey,
}: {
  localStorageKey: string
}) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(localStorageKey)) {
      setShow(true)
    }
  }, [localStorageKey])

  const dontShowAgain = useCallback(() => {
    setShow(false)
    localStorage.setItem(localStorageKey, "yes")
  }, [localStorageKey])

  return { show, dontShowAgain }
}
